module.exports = "<div *ngIf=\"global.loading || window.loading\" class=\"admin-loader\">\n <p class=\"text text-bold\">{{global.loadingText}}</p>\n <div class=\"loader\">\n  <svg class=\"circular\" viewBox=\"25 25 50 50\">\n   <circle class=\"path\" cx=\"50\" cy=\"50\" r=\"20\" fill=\"none\" stroke-width=\"2\" stroke-miterlimit=\"10\" />\n  </svg>\n </div>\n</div>\n<div [class.blured]=\"global.loading || window.loading\">\n <router-outlet></router-outlet>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main